import { useEffect } from "react";
import { enqueue, dequeue } from "redux/actions/ui";
import { useAppDispatch } from "hooks/redux";

export default function LazyLoadingScreen(): any {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(enqueue());

    return () => {
      dispatch(dequeue());
    };
  }, []);

  return null;
}
